import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenRoomPreviewStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 26px 0;
    }
  }
`;
